import { Edit } from "react-admin";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import { useNotification } from "../../../common/hooks/useNotification";
import { EditActions } from "../../common/form/FormActions";
import { FormToolbar } from "../../common/form/FormToolbar";
import { TrailerGpsProviderForm } from "./TrailerGpsProviderForm";

interface Props {}

export const TrailerGpsProviderEdit = (props: Props) => {
  const notify = useNotification(props, "editSuccess");
  const permissions = useActionPermissions();
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-trailer-gps-providers.title.edit"
    >
      <TrailerGpsProviderForm
        toolbar={
          <FormToolbar
            showDeleteButton={
              permissions &&
              permissions[permissionNames.admin.trailerGpsProviders.main] &&
              permissions[permissionNames.admin.trailerGpsProviders.delete]
            }
          />
        }
      />
    </Edit>
  );
};
